<template>
    <div>
      <DashShellComponent
        :has-data="!!selectedFile"
        :tabs="invoiceTabs"
      >
        <!-- Slot for Selection Pane -->
        <template #selection-pane>
          <SelectionPane 
            :fileFormatter="formatFiles" 
            @selected="handleSelection" 
            @add-to-ledger="handleNewEntry"
            @context-changed="getSelectedContext" 
          />
        </template>

        <!-- Slot for Header -->
        <template #header-content>
          <HeaderAndContent 
            :selectedInvoice="selectedFile" 
            :selectedClient="selectedClient" 
            :selectedQuote="selectedQuote" 
          />
        </template>
      </DashShellComponent>
    </div>
</template>

<script>
import axios from "@/plugins/axios"
import companiesJs from "@/plugins/companies"
import helpersJs from "@/plugins/helpers"
import BillingItemsTable from "@/modules/CaseManager/BillingItemsTable.vue";
import ClientManager from "@/modules/Clients/ClientManager.vue"
import CaseDocumentsManager from "@/modules/CaseManager/CaseDocumentsManager.vue";
import CaseChronology from "@/modules/CaseManager/CaseChronology.vue";
import HeaderAndContent from "@/components/General/HeaderAndContent.vue";
import TrustAccountLedger from "@/modules/TrustAccount/TrustAccountLedger.vue"
import Quotations from "@/modules/InvoicesAndQuotes/Quotations.vue";
import PracticeDetailHeader from "./PracticeDetailHeader.vue";
import PracticeDetailCard from "./PracticeDetailCard.vue";
import WelcomeNotice from "@/components/General/WelcomeNotice.vue"
import SelectionPane from "@/components/General/SelectionPane.vue"
import DashShellComponent from "@/components/General/DashShellComponent.vue";

export default {
    components: {
        BillingItemsTable,
        ClientManager,
        CaseDocumentsManager,
        CaseChronology,
        TrustAccountLedger,
        Quotations,
        WelcomeNotice,
        SelectionPane,
        HeaderAndContent,
        PracticeDetailHeader,
        PracticeDetailCard,
        DashShellComponent
    },
    computed:{
        isMobile(){
            return this.$store.getters.isMobile
        },
        getFileLabel(){
            return this.$store.getters.getFileLabel
        },
        getClientLabel(){
            return this.$store.getters.getClientLabel
        },
        getTertiaryColor(){
            return this.$store.getters.getTertiaryColor
        },
        getTrustAccLabel(){
            return this.$store.getters.getTrustAccLabel
        },
        getAuthenticated(){
            return this.$store.getters.getAuthenticated
        },
        getAccessToken(){
            return this.$store.getters.getAccessToken
        },
        getAppMode() {
        return this.$store?.getters?.getAppMode || 'privatePractice';
      },
      getTableName() {
        return this.getAppMode === 'privatePractice' ? 'patient_files' : 'social_work_files';
      },
      invoiceTabs() {
            if (!this.selectedFile) return [];

            return [
              {
                label: '3. Billing & Expenses',
                mobileLabel: '3. Billing',
                icon: 'mdi-cash-register',
                component: BillingItemsTable,
                props: {
                  selectedInvoice: this.selectedFile,
                  itemLabel: 'Invoice',
                  referenceNumber: 'invoice_number'
                },
                on: {
                  'billing-added': this.refreshBillingEntries
                }
              },
              {
                label: `4. ${this.getTrustAccLabel} Account`,
                mobileLabel: '4. Account',
                icon: 'mdi-bank-outline',
                component: TrustAccountLedger,
                props: {
                  scope: 'case',
                  reference: this.selectedFile.invoice_number
                }
              },
              {
                label: `5. ${this.getFileLabel} Details`,
                mobileLabel: '5. File',
                icon: 'mdi-folder-account',
                component: PracticeDetailCard,
                props: {
                  selectedFile: this.selectedFile
                }
              },
              {
                label: '6. Activities & Tasks',
                mobileLabel: '6. Tasks',
                icon: 'mdi-format-list-checks',
                component: CaseChronology,
                props: {
                  caseData: this.selectedFile
                }
              },
              {
                label: '7. Documents',
                mobileLabel: '7. Docs',
                icon: 'mdi-file-document-multiple',
                component: CaseDocumentsManager,
                props: {
                  selectedCase: this.selectedFile,
                  emis: this.selectedFile.emis
                },
                on: {
                  'refresh-documents': this.refreshDocs
                }
              }
            ];
          }
    },
    data: () => ({
        activeTab:null,
        selectedContext: false,
        selectedClient: null,
        selectedFile: null,
        selectedQuote: null
    }),
    async mounted(){
        this.initialiseComponent()
    },
    methods:{
      getSelectedContext(){
        this.selectedFile = null
            this.selectedQuote = null
            this.selectedClient = null
      },
      async initialiseComponent(){
          if(!this.getAuthenticated){
            return;
          }
            const userCompany = await companiesJs.getUserCompany()
            helpersJs.initialiseOrUpdateCompanyDataInStorage(null, userCompany)
            //await this.getAllPractices()
        },
        async getAllPractices(){
          const response = await axios.postDataWithToken("/auth/get-all-practices",{table:this.getTableName},this.getAccessToken)
  
          if(response && response.status === 'success'){
            this.$store.commit('setAllPractices',response.practices)
          }
          
        },
        formatFiles({practices}){
             if(!practices || !practices.length) return []
            const formattedPractices = [];
            practices.forEach(practice => {
                formattedPractices.push({
                    ...practice,
                    name: `${practice.client?.name} | ${practice.invoice_number}`
                })
            });
            return formattedPractices;
        },
        async handleSelection(selection){
          if(!selection) return;
          const category = selection.category
          const selectedItem = selection.data
          this.selectedContext = true;

            if(category === 'primary'){
              await this.getSelectedFile(selectedItem)
            }else if(category === 'client'){
              this.getSelectedClient(selectedItem)
            }else{ //its a quote
              this.getSelectedQuote(selectedItem)
            }
        },
        getSelectedClient(selectedClient){
            this.selectedFile = null
            this.selectedQuote = null
            this.selectedClient = selectedClient
        },
        getSelectedQuote(quote){
          this.selectedClient = null
          this.selectedFile = null
            this.selectedQuote = quote
        },
        getSelectedFile(file){
            this.selectedClient = null;
            this.selectedQuote = null
            this.selectedFile = file;
        },
        refreshDocs(docs){
          this.selectedFile.documents = docs
        },
        refreshBillingEntries(billingEntries) {
          this.selectedFile.billingEntries = billingEntries
        },
        handleNewEntry(newEntry) {
        this.selectedFile.billingEntries.push(newEntry);
        
        this.$store.commit('setLoader',true)
            axios.postDataWithToken("/auth/save-or-update-case-billings",{
              internalRef:this.selectedFile.reference_number,
              invoiceNo: this.selectedFile.invoice_number,
              billingEntries: this.selectedFile.billingEntries
            },
            this.getAccessToken)
            .then(res => {
              this.$store.commit('setLoader',false)
              if(res && res.status == "success"){
                this.$toast.success("Billing entry added successfuly!",{duration:10000})
                this.selectedFile.billingEntries = res.billingEntries
              }else{
                this.$toast.error('Oops, something went wrong!',{duration:10000})
              }
            })
      },
    }
}
</script>
